import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    async setFilter(evt) {
        const filter = evt.target.value;
        const field = evt.target.dataset.field;
        const res = await fetch(`/manager/filter`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
            },
            body: JSON.stringify({ filter, field })
        });
        // reload the page
        window.location.reload();

    }


}
